import no_intro1 from '../../assets/sounds/no/rapidNaming/rapidNaming-intro1.mp3';
import no_intro2 from '../../assets/sounds/no/rapidNaming/rapidNaming-intro2.mp3';
import no_intro3 from '../../assets/sounds/no/rapidNaming/rapidNaming-intro3.mp3';
import no_intro4 from '../../assets/sounds/no/rapidNaming/rapidNaming-intro4.mp3';
import no_intro5 from '../../assets/sounds/no/rapidNaming/rapidNaming-intro5.mp3';

import nn_intro1 from '../../assets/sounds/nn/rapidNaming/rapidNaming-intro1.mp3';
import nn_intro2 from '../../assets/sounds/nn/rapidNaming/rapidNaming-intro2.mp3';
import nn_intro3 from '../../assets/sounds/nn/rapidNaming/rapidNaming-intro3.mp3';
import nn_intro4 from '../../assets/sounds/nn/rapidNaming/rapidNaming-intro4.mp3';
import nn_intro5 from '../../assets/sounds/nn/rapidNaming/rapidNaming-intro5.mp3';

import se_intro1 from '../../assets/sounds/se/rapidNaming/rapidNaming-intro1.mp3';
import se_intro2 from '../../assets/sounds/se/rapidNaming/rapidNaming-intro2.mp3';
import se_intro3 from '../../assets/sounds/se/rapidNaming/rapidNaming-intro3.mp3';
import se_intro4 from '../../assets/sounds/se/rapidNaming/rapidNaming-intro4.mp3';
import se_intro5 from '../../assets/sounds/se/rapidNaming/rapidNaming-intro5.mp3';

import de_intro1 from '../../assets/sounds/de/rapidNaming/rapidNaming-intro1.wav';
import de_intro2 from '../../assets/sounds/de/rapidNaming/rapidNaming-intro2.wav';
import de_intro3 from '../../assets/sounds/de/rapidNaming/rapidNaming-intro3.wav';
import de_intro4 from '../../assets/sounds/de/rapidNaming/rapidNaming-intro4.wav';
import de_intro5 from '../../assets/sounds/de/rapidNaming/rapidNaming-intro5.wav';


import gulblomma from '../../assets/images/rapidNaming/se/flower-yellow.png';
import gronnkake from '../../assets/images/rapidNaming/se/kake_green-min.png';
import rodstjerne from '../../assets/images/rapidNaming/se/stjerne_red-min.png';
import greyApple from '../../assets/images/rapidNaming/se/flower-grey.png';
import gulkake from '../../assets/images/rapidNaming/se/kake_yellow-min.png';
import blastjerne from '../../assets/images/rapidNaming/se/stjerne_blue-min.png';
import gronnsykkel from '../../assets/images/rapidNaming/se/sykkel_gronn-min.png';
import brunkake from '../../assets/images/rapidNaming/se/kake_brown-min.png';
import gulsykkel from '../../assets/images/rapidNaming/se/sykkel_gul-min.png';
import gronnblomma from '../../assets/images/rapidNaming/se/flower-green.png';
import rodkake from '../../assets/images/rapidNaming/se/kake_red-min.png';
import brunsykkel from '../../assets/images/rapidNaming/se/sykkel_brown-min.png';
import blablomma from '../../assets/images/rapidNaming/se/flower-blue.png';
import rodmane from '../../assets/images/rapidNaming/se/moon_red-min.png';
import blasykkel from '../../assets/images/rapidNaming/se/sykkel-blue-min.png';
import gulstjerne from '../../assets/images/rapidNaming/se/stjerne_gul-min.png';
import blamane from '../../assets/images/rapidNaming/se/moon_blue-min.png';
import rodsykkel from '../../assets/images/rapidNaming/se/sykkel_red-min.png';
import gronnstjerne from '../../assets/images/rapidNaming/se/star_green-min.png';
import gulmane from '../../assets/images/rapidNaming/se/moon_yellow-min.png';
import rodblomma from '../../assets/images/rapidNaming/se/flower-red.png';
import blakake from '../../assets/images/rapidNaming/se/kake_blue-min.png';
import gronnmane from '../../assets/images/rapidNaming/se/moon_green-min.png';
import brunblomma from '../../assets/images/rapidNaming/se/flower-brown.png';

import brunmane from '../../assets/images/rapidNaming/se/moon_brown-min.png';
import brunstjerne from '../../assets/images/rapidNaming/se/stjerne_brown-min.png';
export const no = {
	intro1: no_intro1,
	intro2: no_intro2,
	intro3: no_intro3,
	intro4: no_intro4,
	intro5: no_intro5,
};

export const nn = {
	intro1: nn_intro1,
	intro2: nn_intro2,
	intro3: nn_intro3,
	intro4: nn_intro4,
	intro5: nn_intro5,
};

export const se = {
	intro1: se_intro1,
	intro2: se_intro2,
	intro3: se_intro3,
	intro4: se_intro4,
	intro5: se_intro5,
};

export const de = {
	intro1: de_intro1,
	intro2: de_intro2,
	intro3: de_intro3,
	intro4: de_intro4,
	intro5: de_intro5,
};


export const normingGrade567YouthAdultImages = {
	bluebike: blasykkel,
	redflower: rodblomma,
	greenmoon: gronnmane,
	browncake: brunkake,
	yellowstar: gulstjerne,
	blueflower: blablomma,
	greenbike: gronnsykkel,
	redstar: rodstjerne,
	brownmoon: brunmane,
	yellowcake: gulkake,
	greenflower: gronnblomma,
	bluestar: blastjerne,
	redmoon: rodmane,
	brownbike: brunsykkel,
	yellowflower: gulblomma,
	greencake: gronnkake,
	bluemoon: blamane,
	redbike: rodsykkel,
	brownapple: greyApple,
	yellowmoon: gulmane,
	bluecake: blakake,
	greenstar: gronnstjerne,
	redcake: rodkake,
	yellowbike: gulsykkel,
	brownstar: brunstjerne,
	bluemoon2: blamane,
	greenflower2: gronnblomma,
	yellowstar2: gulstjerne,
	redbike2: rodsykkel,
	browncake2: brunkake,
	greenmoon2: gronnmane,
	bluebike2: blasykkel,
	yellowapple2: gulblomma,
	redstar2: rodstjerne,
	brownmoon2: brunmane,
	bluecake2: blakake,
	greenbike2: gronnsykkel,
	yellowmoon2: gulmane,
	redapple2: rodblomma,
	brownstar2: brunstjerne,
	greencake2: gronnkake,
	bluestar2: blastjerne,
	yellowbike2: gulsykkel,
	redmoon2: rodmane,
	blueapple2: blablomma,
	greenstar2: gronnstjerne,
	yellowcake2: gulkake,
	brownapple2: greyApple,
	redcake2: rodkake,
	brownbike2: brunsykkel,
	brownflower:brunblomma,
};